import update from "immutability-helper";

import * as orderActions from "../../../services/orders/actions";
import * as applicationActions from "../../../services/applications/actions";
import * as financingActions from "../../../services/financing/actions";
import * as organisationActions from "../../../services/users/organisations/actions";
import * as notificationActions from "./notification.actions";
import * as accountingActions from "../../../services/accounting/actions";
import * as termsActions from "../../../services/terms/actions";
import * as userActions from "../../../services/users/actions";
import * as specialAccountActions from "../../../services/specialAccounts/actions";
import * as savelendWithdrawalsActions from "../../../services/savelendWithdrawals/actions";
import * as creditSettlementActions from "../../../services/creditSettlement/actions";
import * as borrowerWithdrawal from "../../../services/orders/userProfile/borrower.withdrawal.actions";
import * as amlActions from "../../../services/aml/actions/Aml.Actions";
import * as referAFriendActions from "../../../services/referAFriend/action";
import * as twoFactorAuthActions from "../../../states/2step-authentication/commands/2step.authentication.actions";
import {
  DCA_PAYMENT_REGISTER_ERROR,
  DCA_PAYMENT_REGISTER_SUCCESS,
  DCA_CREDIT_LOSS_REGISTER_ERROR,
  DCA_CREDIT_LOSS_REGISTER_SUCCESS,
} from "../../../services/soldLoans/actions";
import * as systemActions from "../../../services/system/actions";

let initialState = {
  message: null,
};

const orders = (state = initialState, action) => {
  switch (action.type) {
    case orderActions.APPROVE_WITHDRAWAL_ORDER_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Withdrawal was approved",
          Type: "success",
        }),
      });
    case orderActions.APPROVE_WITHDRAWAL_ORDER_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Withdrawal was not approved",
          Type: "error",
        }),
      });
    case orderActions.PLACE_WITHDRAWAL_ORDER_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Withdrawal order was placed",
          Type: "success",
        }),
      });
    case orderActions.PLACE_WITHDRAWAL_ORDER_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Withdrawal order was not placed",
          Type: "error",
        }),
      });
    default:
      return state;
  }
};

const investorDeposits = (state = initialState, action) => {
  switch (action.type) {
    case accountingActions.INVESTOR_DEPOSIT_TRANSFER_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Investor deposit was successful",
          Type: "success",
        }),
      });
    default:
      return state;
  }
};

const applications = (state = initialState, action) => {
  switch (action.type) {
    case applicationActions.APPLICATION_APPROVE_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application was approved",
          Type: "success",
        }),
      });
    case applicationActions.TRANSFER_TO_REVIEW_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application was moved to review",
          Type: "success",
        }),
      });
    case applicationActions.APPLICATION_APPROVE_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application was not approved",
          Type: "error",
        }),
      });
    case applicationActions.APPLICATION_REJECT_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application was rejected",
          Type: "success",
        }),
      });
    case applicationActions.APPLICATION_REJECT_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application was not rejected",
          Type: "error",
        }),
      });
    case applicationActions.APPLICATION_NOMINAL_OFFER_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application nominal offer was created",
          Type: "success",
        }),
      });
    case applicationActions.APPLICATION_NOMINAL_OFFER_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application nominal offer was not created",
          Type: "error",
        }),
      });
    case applicationActions.APPLICATION_RISK_OFFER_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application risk offer was created",
          Type: "success",
        }),
      });
    case applicationActions.APPLICATION_RISK_OFFER_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application risk offer was not created",
          Type: "success",
        }),
      });
    case applicationActions.CREDIT_APPLICATION_EXPIRE_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Failed to expire application",
          Type: "error",
        }),
      });
    case applicationActions.CREDIT_APPLICATION_EXPIRE_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Application successfully expired",
          Type: "success",
        }),
      });
    default:
      return state;
  }
};

const financings = (state = initialState, action) => {
  switch (action.type) {
    case financingActions.FINANCING_REGISTER_PAYOUT_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Financing was paid out",
          Type: "success",
        }),
      });
    case financingActions.FINANCING_REGISTER_PAYOUT_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Financing was not paid out",
          Type: "error",
        }),
      });

    case financingActions.CANCEL_LOAN_PAYOUT_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Loan was cancelled",
          Type: "success",
        }),
      });
    case financingActions.CANCEL_LOAN_PAYOUT_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Loan was not cancelled",
          Type: "error",
        }),
      });
    case financingActions.FINANCING_OPEN_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Financing was opened",
          Type: "success",
        }),
      });
    case financingActions.FINANCING_OPEN_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Financing was not opened",
          Type: "error",
        }),
      });
    case financingActions.FINANCING_REALISE_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Financing realized",
          Type: "success",
        }),
      });
    case financingActions.CANCEL_FINANCING_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Financing was canceled",
          Type: "success",
        }),
      });
    case financingActions.CANCEL_FINANCING_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Financing was not canceled",
          Type: "error",
        }),
      });
    case financingActions.FINANCING_CLOSE_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Financing was closed and won't be visible for lenders",
          Type: "success",
        }),
      });
    case financingActions.FINANCING_CLOSE_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Financing was not closed and will still be visible for lenders",
          Type: "error",
        }),
      });
    default:
      return state;
  }
};

const organisations = (state = initialState, action) => {
  switch (action.type) {
    case organisationActions.ORGANISATION_ADD_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Organisation created",
          Type: "success",
        }),
      });
    case organisationActions.ORGANISATION_ADD_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Organisation not created",
          Type: "error",
        }),
      });
    case organisationActions.ORIGINATOR_ADD_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Originator created",
          Type: "success",
        }),
      });
    case organisationActions.ORIGINATOR_ADD_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Originator not created",
          Type: "error",
        }),
      });
    default:
      return state;
  }
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case userActions.USER_ADD_BANK_ACCOUNT_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Error Creating bank Account",
          Type: "error",
        }),
      });
    case userActions.USER_ADD_BANK_ACCOUNT_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Bank Account Created",
          Type: "success",
        }),
      });
    default:
      return state;
  }
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case notificationActions.SERVER_ERROR:
      /// changed to consol log to meke it more radable
      // eslint-disable-next-line no-console
      console.log(action.Text);
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Server Error: see console log",
          Type: "error",
        }),
      });
    default:
      return state;
  }
};

const accounting = (state = initialState, action) => {
  switch (action.type) {
    case accountingActions.MANUAL_DEPOSIT_MATCH_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Deposit match success",
          Type: "success",
        }),
      });
    case accountingActions.REGISTER_DEPOSIT_PAYMENT_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Deposit register success",
          Type: "success",
        }),
      });
    case accountingActions.REGISTER_DEPOSIT_PAYMENT_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Deposit register error",
          Type: "error",
        }),
      });

    case accountingActions.TRANSFER_INVOICE_PAYMENT_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Invoices confirmed",
          Type: "success",
        }),
      });
    case accountingActions.INVOICE_MATCH_MANUALLY_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Invoice manually matched",
          Type: "success",
        }),
      });
    case accountingActions.REGISTER_INVOICE_PAYMENT_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Invoice register success",
          Type: "success",
        }),
      });
    case accountingActions.REGISTER_INVOICE_PAYMENT_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Invoice register error",
          Type: "error",
        }),
      });

    case accountingActions.REGISTER_MPL_PAYMENT_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "An error has occured while doing MPL repayment",
          Type: "error",
        }),
      });

    case accountingActions.REGISTER_MPL_PAYMENT_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "MPL repayment was successful",
          Type: "success",
        }),
      });

    case DCA_PAYMENT_REGISTER_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "DCA repayment was registered",
          Type: "success",
        }),
      });

    case DCA_PAYMENT_REGISTER_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Error while registering DCA repayment",
          Type: "error",
        }),
      });

    case DCA_CREDIT_LOSS_REGISTER_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "DCA credit loss was registered",
          Type: "success",
        }),
      });

    case DCA_CREDIT_LOSS_REGISTER_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Error while registering DCA credit loss",
          Type: "error",
        }),
      });

    default:
      return state;
  }
};

const terms = (state = initialState, action) => {
  switch (action.type) {
    case termsActions.BORROWER_TERMS_SEND_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Borrower Terms updated",
          Type: "success",
        }),
      });
    case termsActions.LENDER_TERMS_SEND_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Lender Terms updated",
          Type: "success",
        }),
      });
    case termsActions.GENERAL_TERMS_SEND_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Savelend General Terms updated",
          Type: "success",
        }),
      });
    case termsActions.PAYMENT_SERVICE_TERMS_SEND_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Payment Service Terms updated",
          Type: "success",
        }),
      });
    case termsActions.LOANSTEP_GENERAL_TERMS_SEND_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Loanstep General Terms updated",
          Type: "success",
        }),
      });
    default:
      return state;
  }
};

const settlement = (state = initialState, action) => {
  switch (action.type) {
    case creditSettlementActions.CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Credit closed in DCA process",
          Type: "success",
        }),
      });

    case creditSettlementActions.CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "DCA payment registered",
          Type: "success",
        }),
      });

    case creditSettlementActions.CREDIT_SETTLEMENT_SET_DCA_PROCESS_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Credit added to DCA process",
          Type: "success",
        }),
      });
    default:
      return state;
  }
};

const accountTransaction = (state = initialState, action) => {
  switch (action.type) {
    case specialAccountActions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Transaction order was confirmed",
          Type: "success",
        }),
      });

    case specialAccountActions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Transaction order was not confirmed",
          Type: "error",
        }),
      });

    case specialAccountActions.LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Deposit order created",
          Type: "success",
        }),
      });

    case specialAccountActions.LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Deposit order was not created",
          Type: "error",
        }),
      });

    case specialAccountActions.LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Withdraw order created",
          Type: "success",
        }),
      });

    case specialAccountActions.LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Withdraw order was not created",
          Type: "error",
        }),
      });

    case savelendWithdrawalsActions.CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Savelend special account order confirmed",
          Type: "success",
        }),
      });

    case savelendWithdrawalsActions.CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Savelend special account order not confirmed",
          Type: "error",
        }),
      });

    case savelendWithdrawalsActions.CREATE_SAVELEND_SPECIAL_ACCOUNT_WITHDRAWAL_ORDER_ERROR:
    case savelendWithdrawalsActions.CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Savelend special account order creation failed",
          Type: "error",
        }),
      });

    case orderActions.CONFIRM_SEND_BACK_ORDER_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Savelend send back order confirmed",
          Type: "success",
        }),
      });

    case orderActions.CONFIRM_SEND_BACK_ORDER_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Savelend send back order creation failed",
          Type: "error",
        }),
      });

    default:
      return state;
  }
};

const general = (state = initialState, action) => {
  switch (action.type) {
    case "SUCCESS_NOTIFIACTION":
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: action.message,
          Type: "success",
        }),
      });

    case "ERROR_NOTIFIACTION":
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: action.message,
          Type: "error",
        }),
      });

    default:
      return state;
  }
};

const bonus = (state = initialState, action) => {
  switch (action.type) {
    case orderActions.CONFIRM_BONUS_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Bonus confirmed",
          Type: "success",
        }),
      });

    case orderActions.REGISTER_BONUS_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Bonus order created (waiting to be confirmed)",
          Type: "success",
        }),
      });

    case orderActions.CANCEL_BONUS_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Bonus order canceled",
          Type: "success",
        }),
      });

    default:
      return state;
  }
};

const aml = (state = initialState, action) => {
  switch (action.type) {
    case amlActions.CREATE_SEND_BACK_ORDER_SUCCESS:
      return update(state, {
        message: {
          Text: { $set: "Send back order created" },
          Type: { $set: "success" },
        },
      });

    case amlActions.CREATE_SEND_BACK_ORDER_ERROR:
      return update(state, {
        message: {
          Text: { $set: "action.error" },
          Type: { $set: "error" },
        },
      });

    case amlActions.SET_AML_WARNINGS_STATUS_SUCCESS:
    case amlActions.SET_LOANSTEP_AML_WARNINGS_STATUS_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Aml status set",
          Type: "success",
        }),
      });

    case amlActions.SET_AML_WARNINGS_STATUS_ERROR:
    case amlActions.SET_LOANSTEP_AML_WARNINGS_STATUS_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: action.error,
          Type: "error",
        }),
      });

    case amlActions.SET_INVESTOR_AML_RISK_LEVEL_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: action.error,
          Type: "error",
        }),
      });

    case amlActions.SET_BORROWER_AML_RISK_LEVEL_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: action.error,
          Type: "error",
        }),
      });

    default:
      return state;
  }
};

const borrowerWithdrawals = (state = initialState, action) => {
  switch (action.type) {
    case borrowerWithdrawal.CREATE_BORROWER_WITHDRAWAL_SUCCESS:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Withdrawn succesfully.",
          Type: "success",
        }),
      });
    case borrowerWithdrawal.CREATE_BORROWER_WITHDRAWAL_ERROR:
      return Object.assign({}, state, {
        message: Object.assign({}, state.message, {
          Text: "Withdrawal failed",
          Type: "error",
        }),
      });
    default:
      return state;
  }
};

const refAFriend = (state = initialState, action) => {
  switch (action.type) {
    case referAFriendActions.ADD_CAMPAIGN_SUCCESS:
      return update(state, {
        message: {
          $set: {
            Text: "Campaign has been added",
            Type: "success",
          },
        },
      });
    case referAFriendActions.ADD_CAMPAIGN_ERROR:
      return update(state, {
        message: {
          $set: {
            Text: action.message,
            Type: "error",
          },
        },
      });
    case referAFriendActions.DELETE_CAMPAIGN_SUCCESS:
      return update(state, {
        message: {
          $set: {
            Text: "Campaign has been deleted",
            Type: "success",
          },
        },
      });
    case referAFriendActions.DELETE_CAMPAIGN_ERROR:
      return update(state, {
        message: {
          $set: {
            Text: action.message,
            Type: "error",
          },
        },
      });
    case referAFriendActions.UPDATE_END_DATE_SUCCESS:
      return update(state, {
        message: {
          $set: {
            Text: "Campaign has been updated",
            Type: "success",
          },
        },
      });
    case referAFriendActions.UPDATE_END_DATE_ERROR:
      return update(state, {
        message: {
          $set: {
            Text: action.message,
            Type: "error",
          },
        },
      });
    case referAFriendActions.UPDATE_START_DATE_SUCCESS:
      return update(state, {
        message: {
          $set: {
            Text: "Campaign has been updated",
            Type: "success",
          },
        },
      });
    case referAFriendActions.UPDATE_START_DATE_ERROR:
      return update(state, {
        message: {
          $set: {
            Text: action.message,
            Type: "error",
          },
        },
      });
    default:
      return state;
  }
};

const twoFactorAuth = (state = initialState, action) => {
  switch (action.type) {
    case twoFactorAuthActions.ADD_USER_FOR_AUTHENTICATION_ERROR:
      return update(state, {
        message: {
          $set: {
            Text: action.error,
            Type: "error",
          },
        },
      });
    default:
      return state;
  }
};

const system = (state = initialState, action) => {
  switch (action.type) {
    case systemActions.GDPR_REMOVE_SUCCESS:
      return update(state, {
        message: {
          $set: {
            Text: "Account was removed!",
            Type: "success",
          },
        },
      });

    case systemActions.GDPR_REMOVE_ERROR:
      return update(state, {
        message: {
          $set: {
            Text: "Account was not removed!",
            Type: "error",
          },
        },
      });
    case systemActions.GDPR_DEACTIVATE_SUCCESS:
      return update(state, {
        message: {
          $set: {
            Text: "Account was deactivated!",
            Type: "success",
          },
        },
      });

    case systemActions.GDPR_DEACTIVATE_ERROR:
      return update(state, {
        message: {
          $set: {
            Text: "Account was not deactivated!",
            Type: "error",
          },
        },
      });
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  let newState = state;

  newState = orders(newState, action);
  newState = applications(newState, action);
  newState = financings(newState, action);
  newState = organisations(newState, action);
  newState = notifications(newState, action);
  newState = accounting(newState, action);
  newState = terms(newState, action);
  newState = user(newState, action);
  newState = accountTransaction(newState, action);
  newState = general(newState, action);
  newState = settlement(newState, action);
  newState = bonus(newState, action);
  newState = investorDeposits(newState, action);
  newState = aml(newState, action);
  newState = borrowerWithdrawals(newState, action);
  newState = refAFriend(newState, action);
  newState = twoFactorAuth(newState, action);
  newState = system(newState, action);

  return newState;
};
